import { Grid, IconButton, Stack, Typography, Skeleton, CircularProgress } from '@mui/material';
import React from 'react';
import { gridSpacing } from 'store/constant';

const MachineSubscriptionViewModuleSkeleton = () => {
  return (
    <Grid item xs={12} className="machineModalView">
      <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
        <div
          className="address_locationmain"
          style={{ background: '#6fd74b', marginBottom: 2, position: 'relative', padding: '10px 18px' }}
        >
          <Typography component="h4" variant="h3" sx={{ color: '#fff' }}>
            Machine Subscription
          </Typography>
          <IconButton
            style={{
              position: 'absolute',
              right: '15px',
              backgroundColor: '#fff',
              color: '#6fd74b',
              padding: '1px'
            }}
            color="primary"
          >
            {/* <Skeleton variant="circular" width={24} height={24} /> */}
            <CircularProgress sx={{ padding: '3px' }} size={24} />
          </IconButton>
        </div>

        <Grid container spacing={gridSpacing} className="machineModalView" style={{ paddingTop: '20px', paddingBottom: '20px' }}>
          {[
            'Plan Name',
            'Plan Price',
            'Trial Period',
            'Global User Count',
            'Machine Specific User Count',
            'Advertisement Count',
            'Subscription Tax',
            'Subscription Status'
          ].map((label, index) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={index} sx={{ paddingTop: 0 }}>
              <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                    {label} :{' '}
                  </Typography>
                  <Skeleton variant="text" width="35%" sx={{ display: 'inline-block' }} />
                </div>
              </div>
            </Grid>
          ))}

          {/* Description and Features Sections */}
          <Grid item xs={12} sm={12} md={6} lg={6} className="subs_machine_view">
            <div
              style={{
                border: '1px solid #6fd74b',
                borderRadius: '6px',
                marginLeft: 15,
                marginRight: 15,
                marginTop: '20px',
                marginBottom: '10px',
                minHeight: '200px'
              }}
            >
              <div style={{ background: '#6fd74b', color: '#fff', padding: '10px', fontSize: '16px' }}>Subscription Plan Description</div>
              <div style={{ padding: '10px' }}>
                <Skeleton variant="text" width="90%" />
                <Skeleton variant="text" width="80%" />
                <Skeleton variant="text" width="85%" />
              </div>
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <div
              className="subs_featre_bxnew"
              style={{
                border: '1px solid #6fd74b',
                borderRadius: '6px',
                marginLeft: 15,
                marginRight: 15,
                marginTop: '20px',
                marginBottom: '10px',
                minHeight: '200px'
              }}
            >
              <div style={{ background: '#6fd74b', color: '#fff', padding: '10px', fontSize: '16px' }}>Subscription Plan Features</div>
              <div style={{ padding: '10px' }}>
                <Skeleton variant="text" width="70%" />
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="65%" />
              </div>
            </div>
          </Grid>
        </Grid>

        {/* Action Buttons */}
        <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ marginTop: '0px', padding: '0 15px 16px 15px' }}>
          <Skeleton variant="rectangular" width={210} height={40} />
        </Stack>
      </div>
    </Grid>
  );
};

export default MachineSubscriptionViewModuleSkeleton;
